import * as auth from "../auth";
import { brandMark, brandName } from "../icons";
import { busy, h } from "../lib";
import { state } from "../store";
import { flowTrio, heroArt } from "./showcase";

export async function renderLogin(onDone: () => Promise<void>): Promise<HTMLElement> {
  const art = heroArt();
  const dev = auth.isDevMode();
  // 로그인이 끝나면 그림판을 아주 멈춘다(남은 대표 그림을 받지 않고, 7초 타이머도 지운다)
  const done = async () => {
    art.stop();
    await onDone();
  };

  // 배포본: 초대받은 이메일로 Cloudflare 로그인 창에 갔다가 돌아온다 (비밀번호 없음, 메일로 받은 코드)
  const start = h("button", { class: "btn primary large block", type: "button", onclick: () => auth.login() }, "이메일로 시작하기");
  const gift = state.config?.signupCredits ? `처음 들어오면 ${state.config.signupCredits} 크레딧을 드려요. 기본 그림 한 장이 1 크레딧이에요.` : "";

  // 이 PC 시험 서버: 아무 이메일이나 넣으면 들어간다
  const email = h("input", { type: "email", autocomplete: "email", placeholder: "이메일", required: true, "aria-label": "이메일" });
  const submit = h("button", { class: "btn primary large block", type: "submit" }, "로그인");
  const devForm = h(
    "form",
    {
      class: "stack tight",
      onsubmit: async (e: Event) => {
        e.preventDefault();
        await busy(submit, "들어가는 중", async () => {
          const em = email.value.trim();
          if (!em) throw new Error("이메일을 적어 주세요.");
          await auth.devLogin(em);
          await done();
        });
      },
    },
    email,
    submit,
  );
  // 입력칸에 들어가면 대표 그림 넘김을 멈춘다(입력하는 동안 화면이 바뀌지 않게). 칩의 단추로 다시 켤 수 있다
  devForm.addEventListener("focusin", (e) => {
    if (e.target instanceof HTMLInputElement) art.pause();
  });
  const step = (n: number, title: string, desc: string) => h("li", null, h("span", { class: "step-dot num" }, String(n)), h("div", null, h("b", null, title), h("p", { class: "small muted hide-sm" }, desc)));
  // 넓은 화면: 왼쪽 그림판(그림 위에 브랜드·제목·단계) + 오른쪽 카드·흐름 세 장.
  // 960px 이하: 그림 띠(브랜드·AI 이미지 칩) → 카드 → 제목·단계 → 흐름 세 장. 자리는 styles.css '로그인 그림판'
  return h(
    "div",
    { class: "login with-art" },
    h(
      "section",
      { class: "login-hero" },
      art.figure,
      h(
        "div",
        { class: "hero-top" },
        h("div", { class: "brand big" }, brandMark(48, "dark"), brandName(18, "dark")),
        h("p", { class: "tagline" }, h("b", null, "무대 뒤의 기술을, 무대 앞으로."), h("span", { class: "small" }, "공연·이벤트 IT 파트너")),
      ),
      art.caption,
      h(
        "div",
        { class: "hero-bottom" },
        h("h1", null, "만들기 전에,", h("br"), "먼저 세워 보세요."),
        h(
          "ol",
          { class: "steps-intro" },
          step(1, "장소를 보여 주세요", "3D로 만들거나 스케치업 화면·현장 사진·도면을 올려요."),
          step(2, "무대 시안을 골라요", "컨셉을 적으면 AI가 무대를 여러 장 그려요. 하나를 골라 확정해요."),
          step(3, "장면을 골라요", "시간대, 카메라, 사람, 효과를 눌러서 정해요."),
          step(4, "연출컷을 뽑고, 고쳐요", "어긋난 곳만 짚으면 그 부분만 고쳐요. 정한 것은 다음 그림에도 지켜져요."),
        ),
        h("p", { class: "small maker" }, "THE NEXT"),
      ),
    ),
    h(
      "section",
      { class: "card login-card" },
      h("h2", null, dev ? "시험 서버 로그인" : "시작하기"),
      dev
        ? h("p", { class: "muted small" }, "이 PC 시험용이에요. 아무 이메일이나 넣으면 들어가요. 운영자 화면은 dev@local.test 로 들어가세요.")
        : h("p", { class: "muted small" }, "초대받은 이메일로 들어와요. 비밀번호 없이, 메일로 받은 코드를 넣으면 돼요."),
      dev ? devForm : start,
      !dev && gift ? h("p", { class: "muted small" }, gift) : null,
    ),
    flowTrio({ title: "같은 장소가 이렇게 세워져요" }),
  );
}
